import { getShortDateForGivenFormat } from '@/helpers/dateTimeFormatter.js'
import { pipe } from 'ramda'
import { addDays } from 'date-fns'

export function getSurroundingDates({ currentDate, daysLimit }) {
  return [...Array(2 * daysLimit).keys()].map(
    pipe(
      i => addDays(new Date(currentDate), i - daysLimit),
      date => getShortDateForGivenFormat({ date, dateFormat: 'yyyy-MM-dd' }),
    ),
  )
}
